import type { ReactNode } from "react";

interface EmptyStateProps {
  title: string;
  description: string;
  action?: ReactNode;
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-2 px-6 py-14 text-center">
      <p className="text-2xl">🗓️</p>
      <p className="text-sm font-semibold text-ink dark:text-ink-dark">{title}</p>
      <p className="max-w-xs text-sm text-muted dark:text-muted-dark">{description}</p>
      {action}
    </div>
  );
}
